import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ProcessHttpmsgService } from './process-httpmsg.service';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
// import { baseURL } from '../shared/baseUrl';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';

@Injectable({
    providedIn: 'root'
})
export class GeneralService {

    constructor(private http: HttpClient,
        private processHTTPMsgService: ProcessHttpmsgService) { }

    getItems(route): Observable<any> {
        return this.http.get<any>(environment.baseUrl2 + route)
            .pipe(catchError(this.processHTTPMsgService.handlError));
    }

    getItemsWithQuery(route: string, queryParams: any = {}): Observable<any> {
        let params = new HttpParams();
        for (const key in queryParams) {
            if (queryParams.hasOwnProperty(key)) {
                params = params.set(key, queryParams[key]);
            }
        }
        return this.http.get<any>(environment.baseUrl2 + route, { params })
            .pipe(catchError(this.processHTTPMsgService.handlError));
    }

    getItem(route, id): Observable<any> {
        return this.http.get<any>(environment.baseUrl2 + `${route}/` + id)
            .pipe(catchError(this.processHTTPMsgService.handlError));
    }

    addItem(route, data): Observable<any> {
        return this.http.post<any>(environment.baseUrl2 + route, data)
            .pipe(catchError(this.processHTTPMsgService.handlError));
    }

    editItem(route, id: any, data: any): Observable<any> {
        return this.http.put<any>(environment.baseUrl2 + `${route}/` + id, data)
            .pipe(catchError(this.processHTTPMsgService.handlError));
    }

    deleteItem(route, id: any): Observable<any> {
        return this.http.delete<any>(environment.baseUrl2 + `${route}/` + id)
            .pipe(catchError(this.processHTTPMsgService.handlError));
    }


}
